import {Routes} from '@angular/router';

import {UserProfileComponent} from './user-profile/user-profile.component';

export const profileRouting: Routes = [
  {
    path: '',
    component: UserProfileComponent,
  },
];
